import { Arabic } from "flatpickr/dist/l10n/ar"
import arEG from "rsuite/locales/ar_EG"
import enUS from "rsuite/locales/en_US"

/** Portal Arabic language codes (LanguageDropdown / i18n). */
export const isArabicUiLanguage = language => {
  const lang = String(language || "").toLowerCase()
  return lang === "sa" || lang === "ar" || lang.startsWith("ar-")
}

/**
 * " إلى " wrapped in bidi marks. Without them, a date after the Arabic word is
 * reordered (2026-11-05 shows as 05-11-2026). Do not use `unicode-bidi:
 * bidi-override` on range inputs instead: it draws the word reversed ("ىلإ").
 */
const ARABIC_RANGE_SEPARATOR = "‎ ‏إلى‏ ‎"

const ArabicFlatpickrLocale = {
  ...Arabic,
  rangeSeparator: ARABIC_RANGE_SEPARATOR,
}

/** Flatpickr locale object for the active UI language. */
export const getFlatpickrLocale = language =>
  isArabicUiLanguage(language) ? ArabicFlatpickrLocale : undefined

/** RSuite base locale for the active UI language. */
export const getRsuiteBaseLocale = language =>
  isArabicUiLanguage(language) ? arEG : enUS
